import { defineComponent as _defineComponent } from 'vue'
import OptOffer from '@/components/opt-offer.vue';
import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {ref} from 'vue'
import { checkLoggedIn, getUserId } from '@/util/auth';
import { InviteLinks, Meetings} from '@busy-human/opt-library';
import { useUserspace } from '@/store/userspace';



export default /*#__PURE__*/_defineComponent({
  __name: 'invite',
  setup(__props, { expose }) {
  expose();

const route = useRoute();
const router = useRouter();

const loading = ref(false)

const selfMeeting = ref(false)
const linkInUse = ref(false)
watch(() => route.params.offerLink, async offerLink => {
    loading.value = true
    if(offerLink) {
        const invite = await InviteLinks.Collection.fetchInviteForLink(offerLink as string);
        if(!invite) return;

        const linkCreator = invite.payer || invite.collector

        if(checkLoggedIn()) {
            let userId = useUserspace().uid;

            if(linkCreator == userId)
                selfMeeting.value = true

            linkInUse.value = await Meetings.Collection.inviteUsedByUser(invite.$id, userId)
        }

        if(route.query?.skipLanding === 'true'){
            if(selfMeeting.value){
                // console.log("Cannot skip landing, invite is a preview")
            }else
                router.push({name: 'meeting-request', params: { 'offerLink': offerLink }})
        }
    }
    loading.value = false
}, {immediate: true})

const routeTo = (route:string) =>{
    router.push(`/${route}`);
}


const __returned__ = { route, router, loading, selfMeeting, linkInUse, routeTo, OptOffer, watch, useRoute, useRouter, ref, checkLoggedIn, getUserId, InviteLinks, Meetings, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})